import axios from "axios";
import React, { useEffect, useState } from "react";
import { server_API } from "../config";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { getUserPrivilege, selectUuid } from "../features/userid";
import axiosInstance from "../axiosInstance";
import { getLongFormatDate } from "../utils/dateUtils";
import PopoverDropdown from "./ui/Popover";
import { useNavigate } from "react-router-dom";
import { REDIRECTION_LINKS } from "../constants/common";
import { LIST_TYPES } from "../constants/interviewCreditConstants";
import { IoCaretDownOutline } from "react-icons/io5";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import Select from "react-select";

const Profile = () => {
  const [companyData, setCompanyData] = useState({});
  const [name, setName] = useState("");
  const [logo, setLogo] = useState(null);
  const [pnum, setPnum] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [pin, setPin] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [popUp, setPopUp] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [grades, setGrades] = useState([]);
  const [gradeWorkflowEnabled, setGradeWorkflowEnabled] = useState(false);
  const [gradeEditIndex, setGradeEditIndex] = useState(null);
  const [gradeValidationError, setGradeValidationError] = useState("");
  const [activeDept, setActiveDept] = useState("");
  const [country, setCountry] = useState("");
  const [about, setAbout] = useState("");
  const [location, setLocation] = useState("");
  const [pname, setPname] = useState("");
  const [newDepartment, setNewDepartment] = useState("");
  const [deptPopup, setDeptPopup] = useState(false);
  const [personalemail, setPersonalEmail] = useState("");
  const [pw, setPw] = useState("");
  const [editDept, setEditDept] = useState(false);
  const [index, setIndex] = useState(0);
  const [confirmpw, setConfirmPw] = useState("");
  const [counter, setCounter] = useState(3);
  const [totalInterviews, setTotalIntervies] = useState(0);
  const userPrivilege = useSelector(getUserPrivilege);
  const isHiringManager = userPrivilege === "Hiring Manager";
  const [tab, setTab] = useState(isHiringManager ? 1 : 0);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (popUp) {
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }

    if (counter == 0) {
      setPopUp(false);
    }
  }, [counter, popUp]);

  useEffect(() => {
    if (counter == 0) {
      setPopUp(false);
      setCounter(3);
    }
  }, [counter]);

  // const cid = localStorage.getItem("cid");
  // const uuid = localStorage.getItem("uuid");
  const cid = useSelector(selectCid);
  const uuid = useSelector(selectUuid);

  const normalizeGrades = (gradeList = []) => {
    if (!Array.isArray(gradeList)) return [];

    return gradeList.map((item) => ({
      title: item?.title || "",
      grade: item?.grade || "",
      use_in_job_workflows: item?.use_in_job_workflows ?? item?.active ?? true,
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${server_API}/v2/company/get/${cid}`)
      .then((response) => {
        console.log(response);
        setCompanyData(response.data);
        setName(response.data.name);
        setPnum(response.data.phone);
        setEmail(response.data.email);
        setWebsite(response.data.website);
        setAbout(response.data.about);
        setLocation(response.data.location);
        setDepartments(response.data.departments || []);
        const normalizedGrades = normalizeGrades(response.data.grades);
        setGrades(normalizedGrades);
        setGradeWorkflowEnabled(
          normalizedGrades.length > 0
            ? normalizedGrades.some((item) =>
              Boolean(item.use_in_job_workflows),
            )
            : true,
        );
      })
      .catch((error) => {
        console.log(error);
      });
    axiosInstance
      .get(`/v2/user/getuser/${uuid}`)
      .then((res) => {
        console.log(res);
        setPname(res.data.success.name);
        setPersonalEmail(res.data.success.email);
      })
      .catch((err) => {
        console.log(err);
      });
    axiosInstance
      .get(`/v1/company/geturl/${cid}`)
      .then((response) => {
        console.log(response);
        setLogo(response.data.url);
      })
      .catch((err) => {
        console.log(err);
      });
    axiosInstance
      .post(`v2/applicant/interviewstats?companyid=${cid}&page=-1&type=raw`)
      .then((res) => {
        setTotalIntervies(res.data.data.length);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const validateGrades = () => {
    const invalidIndex = grades.findIndex((item) => {
      const hasTitle = Boolean(item.title.trim());
      const hasGrade = Boolean(item.grade.trim());
      return hasTitle !== hasGrade;
    });

    if (invalidIndex !== -1) {
      setGradeValidationError(
        "Title and Grade are both required for each entered row.",
      );
      setGradeEditIndex(invalidIndex);
      return false;
    }

    setGradeValidationError("");
    return true;
  };

  const isGradeRowInvalid = (item) => {
    const hasTitle = Boolean(item.title.trim());
    const hasGrade = Boolean(item.grade.trim());
    return hasTitle !== hasGrade;
  };

  const update = () => {
    if (!validateGrades()) return;

    axios
      .patch(`${server_API}/v2/company/update`, {
        uuid: cid,
        name: name,
        email: email,
        website: website,
        phone: pnum,
        about: about,
        location: location,
        departments: departments,
        grades: grades
          .map((item) => ({
            title: item.title.trim(),
            grade: item.grade.trim(),
            use_in_job_workflows: Boolean(gradeWorkflowEnabled),
          }))
          .filter((item) => item.title && item.grade),
      })
      .then((response) => {
        console.log(response);
        // `logo` is the existing image URL string after fetch; only new picks are File objects.
        const hasNewLogoToUpload = logo instanceof File;
        if (hasNewLogoToUpload) {
          const data = new FormData();
          data.append("file", logo);
          data.append("companyid", cid);
          axios
            .post(`${server_API}/v2/company/logo`, data)
            .then((logoResponse) => {
              console.log(logoResponse);
              setPopUp(true);
              setTimeout(() => window.location.reload(), 2600);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          setPopUp(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const userUpdate = () => {
    const formData = new FormData();
    formData.append("companyid", cid);
    formData.append("name", pname);
    axiosInstance
      .patch(`/v2/user/update`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((response) => {
        if (pw.length > 0 && pw == confirmpw) {
          formData.append("password", pw);

          axiosInstance
            .patch(`/v2/user/update`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              withCredentials: true,
            })
            .then((response) => {
              console.log(response);
              setPw("");
              setConfirmPw("");
              setPopUp(true);
              // navigate('/login')
              // localStorage.clear()
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          setPopUp(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveDept = () => {
    setDepartments([...departments, newDepartment]);
    setDeptPopup(false);
  };

  const updateGrade = (index, key, value) => {
    setGradeValidationError("");
    setGrades((prev) =>
      prev.map((item, idx) =>
        idx === index
          ? {
            ...item,
            [key]:
              key === "grade"
                ? value.replace(/[^a-zA-Z0-9]/g, "")
                : key === "title"
                  ? value.replace(/[^a-zA-Z\s]/g, "")
                  : value,
          }
          : item,
      ),
    );
  };

  const addGrade = () => {
    setGradeValidationError("");
    setGrades((prev) => [
      ...prev,
      { title: "", grade: "", use_in_job_workflows: true },
    ]);
    setGradeEditIndex(grades.length);
  };

  const removeGrade = (index) => {
    setGradeValidationError("");
    setGrades((prev) => prev.filter((_, idx) => idx !== index));
    if (gradeEditIndex === index) {
      setGradeEditIndex(null);
      return;
    }
    if (gradeEditIndex > index) {
      setGradeEditIndex((prev) => prev - 1);
    }
  };

  return (
    <div>
      {popUp && (
        <div className="fixed bottom-3 left-1/2 mx-auto -translate-x-1/2 w-1/3 border bg-emerald-400 border-emerald-600 rounded-xl p-2">
          <p className="text-white text-center">Saved Successfully!</p>
        </div>
      )}
      {deptPopup && (
        <div className="bg-white fixed z-20 left-1/2 top-1/2 p-3 w-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl shadow-xl">
          <button
            onClick={() => {
              setDeptPopup(false);
            }}
            className=""
          >
            X
          </button>
          <p className="text-center my-2 font-semibold text-xl">
            Add a new department
          </p>
          <input
            value={newDepartment}
            onChange={(e) => {
              setNewDepartment(e.target.value);
            }}
            className="w-full outline-none border rounded-xl py-2 px-2"
          ></input>
          <div className="bg-gray-200 h-[0.07rem] rounded-xl my-2 w-full"></div>
          <div className="text-right">
            <button
              onClick={() => {
                saveDept();
              }}
              className="bg-[#09BF89] px-6 text-white  py-2 rounded-xl"
            >
              Save
            </button>
          </div>
        </div>
      )}
      {editDept && (
        <div className="bg-white fixed z-20 left-1/2 top-1/2 p-3 w-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl shadow-xl">
          <button
            onClick={() => {
              setEditDept(false);
            }}
            className=""
          >
            X
          </button>
          <p className="text-center my-2 font-semibold text-xl">
            Edit department
          </p>
          <input
            value={activeDept}
            onChange={(e) => {
              setActiveDept(e.target.value);
            }}
            className="w-full outline-none border rounded-xl py-2 px-2"
          ></input>
          <div className="bg-gray-200 h-[0.07rem] rounded-xl my-2 w-full"></div>
          <div className="flex justify-end space-x-5 items-center">
            <button
              onClick={() => {
                departments.splice(index, 1);
                setEditDept(false);
              }}
              className="bg-red-400 px-6 text-white  py-2 rounded-xl"
            >
              Delete department
            </button>
            <button
              onClick={() => {
                departments.splice(index, 1);
                setDepartments([...departments, activeDept]);
                setEditDept(false);
              }}
              className="bg-[#09BF89] px-6 text-white  py-2 rounded-xl"
            >
              Save
            </button>
          </div>
        </div>
      )}
      <div
        className={
          deptPopup || editDept
            ? "bg-[#f0f4fc] min-h-screen blur"
            : "bg-[#f0f4fc] min-h-screen"
        }
      >
        <div className="px-10 pt-5">
          <p className="text-2xl font-semibold">Profiles</p>

          <div className="flex flex-col w-full py-4">
            <div class="relative w-full h-48 bg-[#C4C4C4]">
              {/* <button onClick={()=>{setParentInvoicesTab(!parentInvoicesTab)}} className="absolute right-10 top-5 bg-[#005CE8] text-white p-2 rounded-lg">
    {
      parentInvoicesTab == 0 ? "Check Invoices": "Profile page"
    }
  </button> */}
              <div class="absolute bottom-0 left-0 transform translate-x-4 translate-y-16">
                <img
                  src={logo || ""}
                  alt="Profile"
                  className="w-32 h-32 rounded-full border-8 border-white aspect-[5/3] object-contain bg-[#C4C4C4] p-2"
                />
              </div>
            </div>
            <div className="bg-white flex justify-between">
              <div className="py-2 pl-16 ml-20">
                <p className="text-2xl  font-semibold text-[#191B1C]">{name}</p>
                {/* <p className="text-base font-poppins font-normal text-[#626C70]">
Real Estate
</p> */}
              </div>
              <div className="flex gap-8 py-2 px-8">
                <div>
                  <p className="text-xl  font-extrabold text-[#191B1C]">
                    {getLongFormatDate(companyData.createdat)}
                  </p>
                  <p className="text-base font-poppins font-normal text-[#626C70]">
                    Started on
                  </p>
                </div>

                <div>
                  <p className="text-xl  font-extrabold text-[#191B1C]">
                    {companyData.jobcount}
                  </p>
                  <p className="text-base font-poppins font-normal text-[#626C70]">
                    Jobs Postings
                  </p>
                </div>
                <PopoverDropdown
                  items={[
                    {
                      label: "Raw",
                      onClick: () =>
                        navigate(
                          `${REDIRECTION_LINKS.interviewCredits}?type=${LIST_TYPES.RAW}`,
                          { state: { companyid: cid } },
                        ),
                    },
                    {
                      label: "Monthly",
                      onClick: () =>
                        navigate(
                          `${REDIRECTION_LINKS.interviewCredits}?type=${LIST_TYPES.MONTHLY}`,
                          { state: { companyid: cid } },
                        ),
                    },
                    {
                      label: "Daily",
                      onClick: () =>
                        navigate(
                          `${REDIRECTION_LINKS.interviewCredits}?type=${LIST_TYPES.DAILY}`,
                          { state: { companyid: cid } },
                        ),
                    },
                  ]}
                  className={"!-right-[25%] w-[100px]"}
                >
                  <div>
                    <p className="text-xl  font-extrabold text-[#191B1C]">
                      {totalInterviews}{" "}
                      <IoCaretDownOutline className="inline-block w-4" />
                    </p>
                    <p className="text-base font-poppins font-normal text-[#626C70]">
                      Total Interviews
                    </p>
                  </div>
                </PopoverDropdown>
              </div>
            </div>
          </div>

          <div className="mt-6 bg-white rounded-xl ">
            <div className="flex items-center justify-start bg-[#F1F4FB] rounded-t-xl">
              {!isHiringManager && (
                <button
                  onClick={() => setTab(0)}
                  className={
                    tab == 0
                      ? "px-5 py-3 bg-white rounded-t-xl font-semibold"
                      : "rounded-t-xl px-5 py-3"
                  }
                >
                  Company profile
                </button>
              )}
              <button
                onClick={() => {
                  setTab(1);
                }}
                className={
                  tab == 1
                    ? "px-5 py-3 bg-white rounded-t-xl font-semibold"
                    : "rounded-t-xl px-5 py-3"
                }
              >
                Personal profile
              </button>
            </div>

            {tab == 0 && !isHiringManager && (
              <div>
                <div className="p-5">
                  <div className="flex flex-col space-y-4">
                    <div className="flex w-full items-center justify-start space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Name <span className="text-red-500"></span>
                        </p>
                        <input
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        ></input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Logo <span className="text-red-500"></span>
                        </p>
                        <input
                          onChange={(e) => {
                            setLogo(e.target.files[0]);
                          }}
                          className="w-full outline-none  px-2 py-1 rounded-lg mt-2"
                          type="file"
                        ></input>
                      </div>
                    </div>
                    <div className="w-1/2">
                      <p className="font-semibold">
                        Phone Number <span className="text-red-500">*</span>
                      </p>
                      <input
                        value={pnum}
                        onChange={(e) => {
                          setPnum(e.target.value);
                        }}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                      ></input>
                    </div>

                    <div className="flex w-full items-center justify-start space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Email <span className="text-red-500"></span>
                        </p>
                        <input
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        ></input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Website <span className="text-red-500"></span>
                        </p>
                        <input
                          value={website}
                          onChange={(e) => {
                            setWebsite(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                        ></input>
                      </div>
                    </div>

                    <div className="flex w-full items-end space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Address <span className="text-red-500"></span>
                        </p>
                        <input
                          value={address1}
                          onChange={(e) => {
                            setAddress1(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                          placeholder="Address Line 1"
                        ></input>
                      </div>
                      <div className="w-1/2">
                        <input
                          value={address2}
                          onChange={(e) => {
                            setAddress2(e.target.value);
                          }}
                          placeholder="Address Line 2"
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                        ></input>
                      </div>
                    </div>
                    <div className="flex w-full space-x-3">
                      <div className="w-1/4">
                        <input
                          placeholder="Pincode"
                          value={pin}
                          onChange={(e) => {
                            setPin(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                        ></input>
                      </div>
                      <div className="w-1/4">
                        <input
                          placeholder="City"
                          value={city}
                          onChange={(e) => {
                            setCity(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                        ></input>
                      </div>
                      <div className="w-1/4">
                        <input
                          placeholder="State/Territory"
                          value={state}
                          onChange={(e) => {
                            setState(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                        ></input>
                      </div>
                      <div className="w-1/4">
                        <input
                          placeholder="Country"
                          value={country}
                          onChange={(e) => {
                            setCountry(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                        ></input>
                      </div>
                    </div>

                    <div className="">
                      <p className="font-semibold">
                        About the Company{" "}
                        <span className="text-red-500">*</span>
                      </p>
                      <textarea
                        rows="3"
                        value={about}
                        onChange={(e) => {
                          setAbout(e.target.value);
                        }}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                      ></textarea>
                    </div>

                    <div className="flex w-full items-start justify-start space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Office Location <span className="text-red-500"></span>
                        </p>
                        <input
                          value={location}
                          onChange={(e) => {
                            setLocation(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        ></input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Departments <span className="text-red-500"></span>
                        </p>
                        <div className="">
                          {departments.map((d, i) => {
                            return (
                              <button
                                key={`${d}-${i}`}
                                onClick={() => {
                                  setIndex(i);
                                  setActiveDept(d);
                                  setEditDept(true);
                                }}
                                className="m-1 text-sm rounded-xl text-white p-2 bg-red-400"
                              >
                                {d}
                              </button>
                            );
                          })}
                          <button
                            onClick={() => {
                              setDeptPopup(true);
                            }}
                            className="m-1 text-sm rounded-xl text-white p-2 bg-cyan-600"
                          >
                            + Add New
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-5">
                          <p className="font-semibold">Grades</p>
                          <label className="flex items-center gap-2 text-sm">
                            <input
                              type="checkbox"
                              checked={gradeWorkflowEnabled}
                              onChange={(e) =>
                                setGradeWorkflowEnabled(e.target.checked)
                              }
                            />
                            <span>
                              Use in Job Workflows:{" "}
                              {gradeWorkflowEnabled ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                        <button
                          type="button"
                          onClick={addGrade}
                          className="text-sm rounded-xl text-white px-3 py-2 bg-cyan-600"
                        >
                          + Add Grade
                        </button>
                      </div>
                      <div className="mt-3">
                        <Table className="border-y">
                          <Thead className="top-0 z-30 bg-white">
                            <Tr>
                              <Th className="border-y items-center py-5 text-center">Grade</Th>
                              <Th className="border-y items-center p-2 text-center">Title</Th>
                              <Th className="border-y items-center p-2 text-center">Action</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {grades.length === 0 ? (
                              <Tr>
                                <Td colSpan={3} className="border-y p-4 text-center text-sm text-[#8F94A1]">
                                  No grades added yet.
                                </Td>
                              </Tr>
                            ) : (
                              grades.map((item, i) => (
                                <Tr key={`grade-${i}`} className="text-center">
                                  <Td className="border-y p-2">
                                    <input
                                      value={item.grade}
                                      onChange={(e) =>
                                        updateGrade(i, "grade", e.target.value)
                                      }
                                      placeholder="Grade"
                                      disabled={gradeEditIndex !== i}
                                      className={`w-full outline-none border px-2 py-1 rounded-lg text-center disabled:bg-[#F7F8FC] disabled:text-[#8F94A1] ${isGradeRowInvalid(item) ? "border-[#F7284A]" : ""}`}
                                    />
                                    {isGradeRowInvalid(item) && (
                                      <p className="text-xs text-[#F7284A] mt-1">
                                        Enter both Title and Grade.
                                      </p>
                                    )}
                                  </Td>
                                  <Td className="border-y p-2">
                                    <input
                                      value={item.title}
                                      onChange={(e) =>
                                        updateGrade(i, "title", e.target.value)
                                      }
                                      placeholder="Title"
                                      disabled={gradeEditIndex !== i}
                                      className={`w-full outline-none border px-2 py-1 rounded-lg text-center disabled:bg-[#F7F8FC] disabled:text-[#8F94A1] ${isGradeRowInvalid(item) ? "border-[#F7284A]" : ""}`}
                                    />
                                  </Td>
                                  <Td className="border-y p-2">
                                    <div className="flex justify-center">
                                      <Select
                                        value={null}
                                        options={[
                                          { value: "edit", label: gradeEditIndex === i ? "Done" : "Edit" },
                                          { value: "remove", label: "Remove" },
                                        ]}
                                        className="w-40"
                                        placeholder="Select Action"
                                        onChange={(selected) => {
                                          if (selected.value === "edit") {
                                            setGradeEditIndex((prev) =>
                                              prev === i ? null : i
                                            );
                                          } else if (selected.value === "remove") {
                                            removeGrade(i);
                                          }
                                        }}
                                      />
                                    </div>
                                  </Td>
                                </Tr>
                              ))
                            )}
                          </Tbody>
                        </Table>
                      </div>
                      {gradeValidationError && (
                        <p className="text-sm text-[#F7284A] mt-2">
                          {gradeValidationError}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                <div className="flex  px-4 space-x-3 py-5 items-center justify-end w-full">
                  <button className="px-6 py-2 bg-white border border-[#F7284A] text-[#F7284A] rounded-xl">
                    Cancel
                  </button>
                  <button
                    className="px-6 py-2 text-white bg-[#09BF89] rounded-xl"
                    onClick={() => {
                      update();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            )}
            {tab == 1 && (
              <div>
                <div className="p-5">
                  <div className="flex flex-col space-y-4">
                    <div className="flex w-full items-center justify-start space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Name <span className="text-red-500"></span>
                        </p>
                        <input
                          value={pname}
                          onChange={(e) => {
                            setPname(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        ></input>
                      </div>

                      <div className="w-1/2">
                        <p className="font-semibold">
                          Email <span className="text-red-500"></span>
                        </p>
                        <p className="w-full text-gray-400 outline-none border px-2 py-1 rounded-lg mt-2">
                          {personalemail}
                        </p>
                      </div>
                    </div>

                    <p className="font-semibold">Change Password</p>
                    <div className="flex w-full items-center justify-start space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Password <span className="text-red-500"></span>
                        </p>
                        <input
                          value={pw}
                          onChange={(e) => {
                            setPw(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        ></input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">
                          Confirm Password{" "}
                          <span className="text-red-500"></span>
                        </p>
                        <input
                          value={confirmpw}
                          onChange={(e) => {
                            setConfirmPw(e.target.value);
                          }}
                          className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                          type="text"
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                <div className="flex  px-4 space-x-3 py-5 items-center justify-end w-full">
                  <button className="px-6 py-2 bg-white border border-[#F7284A] text-[#F7284A] rounded-xl">
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      userUpdate();
                    }}
                    className="px-6 py-2 text-white bg-[#09BF89] rounded-xl"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
